import React from 'react';
import { AddIcon, MinusIcon } from '@avila-tek/ui/src';
import { useNotify } from '../../../hooks';
import { TTotal } from '../../../models';

interface SummaryProps {
  total: TTotal;
  userPoints: number;
  benefitValue: number;
  benefitvalueCount: number;
  setBenefitValueCount: React.Dispatch<React.SetStateAction<number>>;
  setPointsSelectedInCheckout: React.Dispatch<React.SetStateAction<number>>;
}
function PointsInput({
  total,
  userPoints,
  benefitValue,
  benefitvalueCount,
  setBenefitValueCount,
  setPointsSelectedInCheckout,
}: SummaryProps) {
  const notify = useNotify();

  const handleRemovePoints = () => {
    if (userPoints === 0) {
      notify('No posee puntos', 'error');
      return;
    }
    if (benefitvalueCount <= 0) {
      notify('No puede asignar puntos negativos', 'error');
      return;
    }
    setBenefitValueCount((prev) => prev - benefitValue);
    setPointsSelectedInCheckout((prev) => prev - 1);
  };

  const handleAddPoints = () => {
    if (userPoints === 0) {
      notify('No posee puntos', 'error');
      return;
    }
    if (benefitvalueCount >= userPoints) {
      notify('No posee más puntos', 'error');
      return;
    }
    const newTotal = -benefitvalueCount - benefitValue + (total?.total ?? 0);
    if (newTotal < 0) {
      notify(
        'Ya alcanzaste la cantidad maxima de puntos que puedes asignar',
        'error'
      );
      return;
    }
    setBenefitValueCount((prev) => prev + benefitValue);
    setPointsSelectedInCheckout((prev) => prev + 1);
  };

  return (
    <div className="w-full flex justify-between gap-5 mb-5">
      <div className="text-neutral-cold-400">Utilizar</div>
      <div className="text-neutral-cold-700">
        <div className="flex flex-row items-center justify-between rounded-lg border border-neutral-cold-400 w-24">
          <button
            disabled={total?.total === 0}
            className="p-2 placeholder:text-black cursor-pointer"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              handleRemovePoints();
            }}
          >
            <MinusIcon className="w-5 h-5 text-neutral-500 hover:text-color-primary-text-100" />
          </button>
          <p className="text-text-black">{benefitvalueCount}</p>
          <button
            disabled={total?.total === 0}
            className="p-2 placeholder:text-black cursor-pointer"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              handleAddPoints();
            }}
          >
            <AddIcon className="w-5 h-5 text-neutral-500 hover:text-color-primary-text-100" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default PointsInput;
